export default __webpack_public_path__ + "493071fd7d5747c342f8a9598348ef98.svg";